import { PrimaryTextColor,primaryRedColor, primaryGrayBg, boldFont, getRelativeFontSize, mediumFont, heading, primaryBlueColor, primaryLightGray, primaryWhiteColor, regularFont, subHeading, PrimaryLightTextColor, borderColor, primarygreenColor, borderRadius } from "../../../../utils/styles";

const ShowAllStyles = {
  headerWrapper: {
    padding: "0 20px",
  },
  pageHeading: {
    ...heading,
  },
  sideBoxWrapper:{
    padding: "20px",
    height: "90vh",
    width: "100%",
    backgroundColor: "rgb(255 255 255)",
    overflow : "auto",
    '&::-webkit-scrollbar': {
    display: "none",
    width:"0px"
}
  },
  closeButton: {
    position: "fixed",
    top: "70px",
    right: "12px",
    zIndex: "9999",
  },
  closeIcon:{
    fontSize: "1rem",
  },
  // autocompleteStyle: {
  //   width: "200px",
  //   maxHeight:'40px',
  //   // background: "#e7e7e7",

  //   "& .MuiSvgIcon-root ":{
  //     display:"none"
  //   },
  //   "& .MuiInputBase-input": {
  //     color: PrimaryTextColor,
  //     ...regularFont,
  //     fontSize: getRelativeFontSize(0),

  //     "&::placeholder": {
  //       ...regularFont,
  //       fontSize: getRelativeFontSize(0),
  //       color: PrimaryLightTextColor,
  //     },
  //   },
  //   "&  .MuiOutlinedInput-root": {
  //     padding: "0.5px 9px",
  //   },
  //   "&  .MuiTextField-root": {
  //     maxHeight:'38px',
  //   },
  //   "& .MuiOutlinedInput-root": {
  //     borderRadius: "4px",
  //     display:'flex',
  //     flexWrap: "initial",
  //     overflow:'hidden',
  //     height:"38px",
  //     "&.Mui-focused fieldset": {
  //       borderColor: "#E7E7EA",
  //     },
  //     "&:hover fieldset": {
  //       borderColor: "#E7E7EA",
  //     },
  //   },
  //   "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
  //     borderColor: "#E7E7EA",
  //   },
  //   "& .MuiAutocomplete-tag":{
  //     height:"auto",
  //   },
  //   "& .MuiChip-label":{
  //     fontSize:"11px",
  //     padding:"0 8px",
      
  //   },
  //   "& .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium":{
  //     fontSize:"16px",
  //   },
   
  // },
  
  autocompleteStyle: {
    maxHeight: "40px", // Fixed height for the input field
    overflow: "hidden", // Prevent vertical overflow
    "& .MuiAutocomplete-tag": {
      height: "auto",
    },
    "& .MuiChip-root": {
      maxWidth: "none", // Allow chips to take their natural size
      overflow: "hidden", // Prevent text overflow
      textOverflow: "ellipsis", // Truncate text with ellipsis
      whiteSpace: "nowrap", // Prevent text wrapping
    },
    "& .MuiChip-label": {
      fontSize: "11px", // Adjust font size for better fit
      padding: "0 8px",
      textOverflow: "ellipsis", // Truncate text with ellipsis
      whiteSpace: "nowrap", // Prevent text wrapping
      overflow: "hidden", // Hide overflowing text
    },
    "& .MuiAutocomplete-popupIndicator": {
      marginLeft: "auto",
    },
    "& .MuiTextField-root": {
      maxHeight: "38px",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      display: "flex",
      flexWrap: "nowrap", // Keep everything in a single line
      overflow: "hidden", // Hide overflowing chips
      height: "40px", // Fixed height for consistent layout
      fontSize: "14px",
      alignItems: "center", // Align items vertically
      "&.Mui-focused fieldset": {
        borderColor: "#E7E7EA",
      },
      "&:hover fieldset": {
        borderColor: "#E7E7EA",
      },
    },
    "& .MuiAutocomplete-input": {
      minWidth: "0px",
    },
   "& .MuiSvgIcon-root ":{
      display:"none"
    },
    "& .MuiAutocomplete-inputRoot": {
      paddingRight: "0px",
      alignItems: "center", // Center align chips and input
    },
  },
  
  autoInputBlank: {
    "& .MuiFormHelperText-root.Mui-error": {
      color: "#d32f2f",
      fontSize: getRelativeFontSize(),
      ...regularFont,
      marginLeft: "5px",
      marginBottom: "5px",
    },
    "& .MuiAutocomplete-input": {
      fontSize: getRelativeFontSize(),
      padding:"4px 5px",
    },
  },

  autoInputFill: {
    "& .MuiFormHelperText-root.Mui-error": {
      color: "#d32f2f",
      fontSize: getRelativeFontSize(-3),
      ...regularFont,
      // marginLeft: "5px",
      marginBottom: "5px",
    },
  },
  content: {
    padding: "0 70px",
  },
  checkBoxWarapper: {
    diplay: "flex",
    marginTop: "10px",
  },
  pageSubHeading: {
    ...subHeading,
  },
  statusHeading: {
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(),
    ...mediumFont,
  },
  showAllWrapper: {
    "& .MuiDataGrid-columnHeaderTitle":{
      ...boldFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(0),
    textTransform: "capitalize",
    },
    "& .MuiTablePagination-root":{
      ...regularFont,
      color: PrimaryTextColor,
      fontSize: getRelativeFontSize(0),

      "& .MuiTablePagination-selectLabel":{
        fontSize: getRelativeFontSize(0),
      },
      "& .MuiTablePagination-displayedRows":{
        fontSize: getRelativeFontSize(0),
      },
      
    },
    "& .MuiDataGrid-toolbarContainer":{
      ...regularFont,
      fontSize: getRelativeFontSize(0),

      "& .MuiInputBase-root":{
        ...regularFont,
        fontSize: getRelativeFontSize(0),

        "& .MuiSvgIcon-root":{
          fontSize:"1.2rem",
        },
      },
      "& .MuiButtonBase-root":{
        ...regularFont,
        fontSize: getRelativeFontSize(0),

        "& .MuiButton-startIcon":{
          marginRight:"0.313rem",
          marginLeft:"0",

          "& .MuiSvgIcon-root":{
            fontSize:"1.2rem",
          },
        },
      },
    },
    "& .MuiStack-root>:not(style):not(style)":{
      marginTop:"0",
    },
    "& .MuiSelect-select":{
      padding:"5px 10px",
    },
  },
  showAllWrapper1: {
    "& .MuiDataGrid-columnHeaderTitle":{
      ...boldFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(0),
    textTransform: "capitalize",
    },
    "& .MuiTablePagination-root":{
      ...regularFont,
      color: PrimaryTextColor,
      fontSize: getRelativeFontSize(0),

      "& .MuiTablePagination-selectLabel":{
        fontSize: getRelativeFontSize(0),
      },
      "& .MuiTablePagination-displayedRows":{
        fontSize: getRelativeFontSize(0),
      },
      
    },
    "& .MuiDataGrid-toolbarContainer":{
      ...regularFont,
      fontSize: getRelativeFontSize(0),

      "& .MuiInputBase-root":{
        ...regularFont,
        fontSize: getRelativeFontSize(0),

        "& .MuiSvgIcon-root":{
          fontSize:"1.2rem",
        },
      },
      "& .MuiButtonBase-root":{
        ...regularFont,
        fontSize: getRelativeFontSize(0),

        "& .MuiButton-startIcon":{
          marginRight:"0.313rem",
          marginLeft:"0",

          "& .MuiSvgIcon-root":{
            fontSize:"1.2rem",
          },
        },
      },
    },
    "& .MuiStack-root>:not(style):not(style)":{
      marginTop:"0",
    },
    "& .MuiSelect-select":{
      padding:"5px 10px",
    },
  },
  menuPart:{
    display:"flex",
    alignItems:"center",
    justifyContent:"space-between",
    // position:"fixed"
  },
  selectBox:{
    // width:"10%",
    display:"flex",
    gap:"10px",
    // padding:"1px 10px",
  
    "& .MuiInputBase-input":{
      fontSize : getRelativeFontSize(0),
    },
    "& .MuiAutocomplete-inputFocused":{
      fontSize : getRelativeFontSize(0),
    },
    "& .MuiAutocomplete-root":{
      maxHeight:"100%",
      // background:primaryGrayBg,
    },
  },

  selectBox1:{
    // width:"10%",
    display:"flex",
    gap:"10px",
    // padding:"1px 10px",
    width:"60%",
    justifyContent:"end",
  
    "& .MuiInputBase-input":{
      fontSize : getRelativeFontSize(0),
    },
    "& .MuiAutocomplete-inputFocused":{
      fontSize : getRelativeFontSize(0),
    },
    "& .MuiAutocomplete-root":{
      maxHeight:"100%",
      // background:primaryGrayBg,
    },


   
    datePicker:{
      border:"1px solid #e0e0e0",
      padding:"5px 48px",
      borderRadius:"4px",
      fontSize:"14px",
      cursor:"pointer",
      fontWeight:"600",
       height:"36px"
  },
  },

  filterBold:{
    fontSize:"12px",
    // fontWeight:600,
    display:"flex",
    alignItems:"center"

  },
  topPart:{
    display:"flex",
    justifyContent:"end"
  },
  datePickerBox:{
    "& .MuiFormLabel-root":{
      fontSize: getRelativeFontSize(0),
      top:"-7px",
    },
    "& .MuiInputBase-input": {
      color: PrimaryTextColor,
      ...regularFont,
      fontSize: getRelativeFontSize(0),
      padding:"9px 10px",
   
    },
    "& .MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"0px"
    }
  },
  buttonArea: {
    display:"flex",
    alignItems:"center",
    justifyContent:"end",
    width:"25%",
    marginTop:"-38px",
    "& button":{
      width:"auto",
      minWidth:"150px",
    },
  },
  reminder:{
    ...boldFont,
    fontSize: getRelativeFontSize(-2),
    color:primarygreenColor,
    background:primaryWhiteColor,
    border:"1px solid",
    borderColor:primarygreenColor,
    borderRadius:"4px",
    height: "32px",
    width: "70px",
    padding:"6px",
  },
  expired:{
    ...boldFont,
    fontSize: getRelativeFontSize(-2),
    color:primaryRedColor,
    background:primaryWhiteColor,
    border:"1px solid",
    borderColor:primaryRedColor,
    borderRadius:"4px",
    height: "32px",
    width: "70px",
    padding:"6px",
    textAlign: 'center',  
    display: 'flex',     
    justifyContent: 'center',
    alignItems: 'center', 
  },
  stageButton:{
    "& .stageBtn":{
      height: "auto",
      width: "auto",
      padding:"4px 12px",
      ...boldFont,
      fontSize: getRelativeFontSize(-3),
      textTransform:"capitalize",
      background:"#cd9118",
      border:"1px solid #cd9118",
      borderRadius:"4px",
      color: primaryWhiteColor,
      cursor:"pointer",

      "&:hover": {
        background:primaryWhiteColor,
        color:"#cd9118",
      },
    },
  },
  assignButton:{
    "& .assignBtn":{
      height: "auto",
      width: "auto",
      padding:"4px 12px",
      ...boldFont,
      fontSize: getRelativeFontSize(-3),
      textTransform:"capitalize",
      background:"#4ca2be",
      border:"1px solid #4ca2be",
      borderRadius:"4px",
      color: primaryWhiteColor,
      cursor:"pointer",

      "&:hover": {
        background:primaryWhiteColor,
        color:"#4ca2be",
      },
    },
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "5px",
    flexDirection: "column",

    "& button": {
      color: primaryBlueColor,
      height: "10px",
      fontSize: getRelativeFontSize(-2),
    },
  },

  buttonWrapperDialog: {
    width: "350px",
    display: "flex",
    justifyContent: "flex-start",
    gap: "10px",
    "& button": {
      color: primaryBlueColor,
      fontSize: getRelativeFontSize(-2),
      "&:nth-child(2)": {
        color: "#ffffff",
      },
    },
  },

  subHeaderName: {
    ...regularFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-3),
    textTransform: "capitalize",
    display:"flex",
  },
 
  headerName: {
    ...boldFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
    textTransform: "capitalize",
 
  },
  dipt: {
    color: "#6D6E82",
    ...boldFont,
  },



  emp_type_btn: {
    background: "#18CB8A",
    width: "60px",
    height: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: getRelativeFontSize(-4),
    textTransform: "capitalize",
    ...regularFont,
    borderRadius: "4px",
    color: "#ffffff",
  },

  activeBtn: {
    "& button": {
      height: "23px",
      width: "54px",
      fontSize: getRelativeFontSize(-3),
      ...mediumFont,
    },
  },

  deActive: {
    "& button": {
      height: "23px",
      width: "54px",
      fontSize: getRelativeFontSize(-3),
      ...mediumFont,
      background: "red",
      borderColor: "red",
      "&:hover": {
        background: "red",
        borderColor: "red",
      },
    },
  },

  popOverContent: {
    position: "relative",
    top: "20px",
  },

  popOverBtn: {
    position: "absolute",
  },

  Info_btn: {
    height: "18px",
    width: "fit-content",
    padding: "0 10px",
    ...regularFont,
    borderRadius: "4px",
    background: "#F4BE5E",
    fontSize: getRelativeFontSize(-4),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "5px",
    color: "#ffffff",
    textTransform: "capitalize",
  },

  filterButton: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    justifyContent: "center",
    height: "46px",
  },

  filterName: {
    ...mediumFont,
    fontSize: getRelativeFontSize(2),
    color: "#11142D",
    "& img": {
      marginLeft: "10px",
    },
  },

  verticalDotButton: {
    "& button": {
      "&:hover": {
        background: "none",
      },
    },
  },

  innerPopOver: {
    padding: "5px",
    display: "flex",
    width: "100%",
    height: "100%",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "start",

    "& button": {
      width: "auto",
      height:"auto",
      minWidth:"auto",
      padding:"4px",
      fontSize:"12px",

      "&:hover": {
        background: "none",
      },
    },
  },
  customgridStyle:{
    "& .css-yrdy0g-MuiDataGrid-columnHeaderRow":{
      display: "flex",
    justifyContent: "space-between",
    width: "90vW",
    },
  },
  leadName:{
    ...boldFont,
    fontSize: getRelativeFontSize(-2),
    color: PrimaryTextColor,
    lineHeight: "24px",
    textTransform:"capitalize",
  },
  leadName1 : {
    ...mediumFont,
    fontSize: getRelativeFontSize(-2),
    color: primaryLightGray,
    lineHeight: "18px",
  },
  infoSection :{
    display :"flex",
    flexDirection:"column",
    justifyContent :"space-between",

    "& .MuiTypography-root" :{
      ...regularFont,
      fontSize: getRelativeFontSize(-3),
      lineHeight: "18px",
      color: primaryLightGray,
    },
  },
  faceBook : {
    color : "#8B91EF !important",
  },
  callSection : {
    display:"flex",
    justifyContent:"space-between",
    color: primaryBlueColor,

    "& a":{
      ...regularFont,
      display:"flex",
      alignItems:"center",
      justifyContent:"space-between",
      color: primaryBlueColor,
      textDecoration:"none",
      fontSize: getRelativeFontSize(0),
    },

    "& .MuiBox-root" : {
      display: "flex",
      gap: "5px",
      alignItems: "center",
    },
    "& .MuiTypography-root" : {
      fontSize: getRelativeFontSize(0),
    },
    "& .MuiSvgIcon-root" : {
      fontSize: getRelativeFontSize(4),
    },
  },
  editIcon: {
    color: primaryLightGray,
  },
  whatsAppSection : {
    display:"flex",
    justifyContent:"space-between",
    color: "#075e54",
    "& .MuiBox-root" : {
      display: "flex",
      gap: "5px",
      alignItems: "center",
    },
    "& .MuiTypography-root" : {
      fontSize: getRelativeFontSize(0),
    },
    "& .MuiSvgIcon-root" : {
      fontSize: getRelativeFontSize(4),
    },
  },
  formPart:{
    marginLeft:"8px",
    "& .MuiFormLabel-root" : {
      fontSize: getRelativeFontSize(0),
    },
    "& .MuiTypography-root" : {
      fontSize: getRelativeFontSize(-2),
    },
    "& .MuiSvgIcon-root" : {
      fontSize: "1.2rem",
    },
    "& .MuiRadio-root":{
      padding: "4px",
      color: primaryBlueColor,
    },

  },
  inputPart :{
    "& .MuiFormControl-root":{
      display:"flex",
    },
    "& .MuiAutocomplete-input":{
      padding: "5px 10px",
    },
    "& .MuiInputBase-input":{
      fontSize: getRelativeFontSize(-3),
      padding: "5px 10px",
    },   
  },
  dateTimeSection:{
    marginTop:"10px",
    "& .MuiFormControl-root":{
      display: "flex",
    },
    "& .MuiInputBase-input" : {
      padding : "10px 5px",
      fontSize : getRelativeFontSize(-3),
    },
  },
  buttonPart: {
    display: "flex",
    justifyContent: "end",
    "& .MuiButtonBase-root":{
      width:"auto",
      height: "auto",
      padding: "1px 5px",
      fontSize : getRelativeFontSize(-3),
      minWidth: "55px",
    },
  },
  reminderPart: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  iconsPart: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "5px",
    "& .MuiSvgIcon-root" : {
      fontSize : getRelativeFontSize(0),
    },
  },
  
  // buttonBox:{
  //   marginLeft:"5%",
  //   "& .MuiButtonBase-root":{
  //     height:"41px",
  //   },
  // },
 
  tableGridPart:{
    position: "relative",

    "& .MuiDataGrid-withBorderColor":{
      border: "none",
    },
    "& .MuiDataGrid-main": {
      borderTop: "1px solid #EEEFF2",
    },
    "& .MuiDataGrid-columnHeaders":{
      borderBottom: "1px solid #EEEFF2",
      fontSize:"14px",
      ...boldFont
    },
    "& .MuiDataGrid-rowCount":{
      display:"none",
    },
    "& .MuiSelect-select":{
      fontSize:"14px",
      padding:"4px 10px",
      border:"none",
      outline:"none",
    },
    "& .MuiOutlinedInput-notchedOutline":{
      border:"none",
      outline:"none",
    },
    "& .activeButton":{
      margin:"0 5px",background:"#3D48E5", border:"1px solid #3D48E5",
      color:"#fff",padding:"4px", fontSize:"12px", borderRadius:"4px",
      minWidth:"30px",
      "& .activeButton:hover":{
        backgroundColor:"#3D48E5",
      },
      "& .MuiSvgIcon-root":{
        width:"0.8em",
        height:"0.8em",
      },
    },
    "& .deActiveButton":{
      margin:"0 5px",background:"#e7e7e7", border:"1px solid #e7e7e7",
      color:"#bbb",padding:"4px", fontSize:"12px", borderRadius:"4px",
      minWidth:"30px",
      "& .activeButton:hover":{
        backgroundColor:"#3D48E5",
      },
      "& .MuiSvgIcon-root":{
        width:"0.8em",
        height:"0.8em",
      },
    },
  },

  popUpBox:{
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "380px",
    margin:"0 auto",
    backgroundColor: primaryWhiteColor,
    border: "1px solid #e0e0e0",
    borderRadius:"4px",
    boxShadow:"",
    padding:"20px",

    "& .heading":{
      ...boldFont,
      fontSize : getRelativeFontSize(4),
      marginBottom:"0.5em",
    },
    "& .teamArea":{
      display:"flex",
      alignItems:"center",
      gap:"1rem",

      "& .teamName":{
        ...boldFont,
        fontSize : getRelativeFontSize(0),
        color:PrimaryTextColor,
      },
      "& .memberNameArea":{
        display:"flex",
        alignItems:"center",
        gap:"0.5rem",
        

        "& .memberName":{
          ...regularFont,
          fontSize : getRelativeFontSize(0),
          color:PrimaryTextColor,
          overflowY: "auto"
        },
      },
    },
  },
  clickableRow: {
    cursor: 'pointer',
  },
  link:{
       color:"#3D48E5"
  },

  footer:{
    position: "sticky",
    width: "100%",
    bottom: "0",
    background: "#f7f7f7",
    borderTop: "1px solid #E7E7EA",
    padding: "5px",
    height:"48px",
    display:"flex",
    justifyContent:"end",
  },
  footerRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    fontSize: '11px',
    alignItems: 'center'
  },
  font:{
    "& .MuiPaginationItem-root":{
      fontSize:"13px"
    }
  },
  inputStyle:{
    width:"100%",
    height:'40px',
  },
  dataGridPro: {
    border: 'none',
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#f5f5f5',
      color: '#333',
      fontSize: '1rem',
      fontWeight: 'bold',
     
    },
    '& .MuiDataGrid-virtualScroller': {
      backgroundColor: '#fff',
      
    },
  },

  noDataFound: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    typography: {
      fontWeight: 'bold',
          fontSize : getRelativeFontSize(4),
          color:PrimaryTextColor,
    },
  },
  searchBar:{
    fontWeight:400,
    fontSize:"12px",
    // marginBottom:"10px",
    marginTop:"-37px",
    width:"400px",
    '& input::placeholder': {
      fontSize: '14px',
      lineHeight: '12px',
    },
    '& .MuiSvgIcon-root': {
      height: "20px",
      width: "20px"
    }
  },
  
callBox: {
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  padding: "5px",
  backgroundColor: "#28a745", // Bootstrap-like green
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "600",
  fontSize: "14px",
  textDecoration: "none",
  transition: "background-color 0.2s ease, transform 0.2s ease",
  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
width:"100%",
justifyContent:"center",
  "&:hover": {
    backgroundColor: "#218838", // Darker green
    transform: "translateY(-1px)"
  },

  "&:active": {
    backgroundColor: "#1e7e34",
    transform: "translateY(0)"
  }
},

phoneIcon: {
  fontSize: "18px",
  color: "#fff", // white to match button text
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}


}
export default ShowAllStyles;
